import React from 'react'
import { StyledIconPropsType } from './types'

type Props = StyledIconPropsType &  { custom?: boolean }

const PackageWMO = ({
  icon = "package",
  viewBox= "0 0 32 32",
  width = "32px",
  height = "32px",
  customProps = {},
  custom = false
} : Props) => {
  if(custom) {
    return (
      <svg aria-label={icon} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...customProps}>
        <path d="M30.25 17.7338L13.75 8.21875" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M38.5 29.8338V15.1671C38.4993 14.5241 38.3296 13.8926 38.0078 13.3359C37.686 12.7793 37.2235 12.317 36.6667 11.9955L23.8333 4.66214C23.2759 4.34032 22.6436 4.1709 22 4.1709C21.3564 4.1709 20.7241 4.34032 20.1667 4.66214L7.33333 11.9955C6.77648 12.317 6.31396 12.7793 5.99218 13.3359C5.6704 13.8926 5.50066 14.5241 5.5 15.1671V29.8338C5.50066 30.4768 5.6704 31.1083 5.99218 31.665C6.31396 32.2217 6.77648 32.684 7.33333 33.0055L20.1667 40.3388C20.7241 40.6606 21.3564 40.8301 22 40.8301C22.6436 40.8301 23.2759 40.6606 23.8333 40.3388L36.6667 33.0055C37.2235 32.684 37.686 32.2217 38.0078 31.665C38.3296 31.1083 38.4993 30.4768 38.5 29.8338Z" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.99609 13.2598L22.0011 22.5181L38.0061 13.2598" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22 40.98V22.5" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  }

  return (
    <svg aria-label={icon} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...customProps}>
      <path d="M22 12.5352L10 5.61523" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M28 21.3339V10.6672C27.9995 10.1996 27.8761 9.74027 27.6421 9.3354C27.408 8.93054 27.0717 8.59434 26.6667 8.36052L17.3333 3.02719C16.9279 2.79314 16.4681 2.66992 16 2.66992C15.5319 2.66992 15.0721 2.79314 14.6667 3.02719L5.33333 8.36052C4.92835 8.59434 4.59197 8.93054 4.35795 9.3354C4.12392 9.74027 4.00048 10.1996 4 10.6672V21.3339C4.00048 21.8015 4.12392 22.2608 4.35795 22.6656C4.59197 23.0705 4.92835 23.4067 5.33333 23.6405L14.6667 28.9739C15.0721 29.2079 15.5319 29.3311 16 29.3311C16.4681 29.3311 16.9279 29.2079 17.3333 28.9739L26.6667 23.6405C27.0717 23.4067 27.408 23.0705 27.6421 22.6656C27.8761 22.2608 27.9995 21.8015 28 21.3339Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.35938 9.2793L15.9994 16.0126L27.6394 9.2793" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 29.44V16" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default PackageWMO
